import { useRouteError } from 'react-router-dom';

/**
 * Component that rethrows React Router errors to allow them to bubble up
 * to parent error boundaries (like the one in VersionChecker that reports to Sentry).
 *
 * React Router v6 has built-in error boundaries that catch errors and prevent
 * them from bubbling up. This component captures the router error and rethrows
 * it during render, allowing parent error boundaries to handle it properly.
 */
export function ErrorRethrow() {
  const error = useRouteError();

  // Rethrow the error during render so it bubbles up to parent error boundaries
  if (error) {
    throw error;
  }

  // This should never be reached, but just in case
  return null;
}
